import { v4 as uuid4 } from 'uuid';

const data = [
    {
        id: uuid4(),
        title: "Исследование ниши и стратегия развития",
        img: "./icons/Icon1.png"
    },
    {
        id: uuid4(),
        title: "Прототипирование UI | UX дизайна для продукта",
        img: "./icons/Icons2.png"
    },
    {
        id: uuid4(),
        title: "Анализ конкурентов и юзабилити тесты",
        img: "./icons/Icons2.png"
    },
    {
        id: uuid4(),
        title: "Разработка и верстка",
        img: "./icons/Icon5.png"
    },
    {
        id: uuid4(),
        title: "Семантическая структура и оптимизация",
        img: "./icons/Icons3.png"
    },
    {
        id: uuid4(),
        title: "Финальное тестирование и запуск продукта",
        img: "./icons/Icons6.png"
    },
]

export default data